import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center" }
const _hoisted_2 = { class: "mx-4 px-3 py-2 border-black border-1 rounded-10 text-xs" }

import { watch, ref, onMounted } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SpinnerQuantityInput',
  props: {
        modelValue: { type: Number, default: null },
        minValue: { type: Number, default: 0 }
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const quantityValue = ref(props.modelValue || props.minValue);
    const emit = __emit;

    watch(props, () => {
        if (props.modelValue) {
            quantityValue.value = props.modelValue;
        }
    }, { deep: true });
    
    watch(quantityValue, () => {
        emit('update:modelValue', quantityValue.value);
    }, { deep: true });

    function increment() {
        quantityValue.value += 1;
    }

    function decrement() {
        if (quantityValue.value > props.minValue) {
            quantityValue.value -= 1;
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn xs square black stroke mx-0",
      onClick: decrement
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("img", {
        src: "/public/icons/icon-retirer.svg",
        class: "btn-icon",
        alt: ""
      }, null, -1)
    ]))]),
    _createElementVNode("h6", _hoisted_2, _toDisplayString(quantityValue.value), 1),
    _createElementVNode("button", {
      class: "btn xs square black stroke mx-0",
      onClick: increment
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("img", {
        src: "/public/icons/icon-ajouter.svg",
        class: "btn-icon",
        alt: ""
      }, null, -1)
    ]))])
  ]))
}
}

})